import { render, staticRenderFns } from "./CreateModerationRuleModal.vue?vue&type=template&id=174750a4&"
import script from "./CreateModerationRuleModal.vue?vue&type=script&lang=js&"
export * from "./CreateModerationRuleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports